import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { CategorySelectComponent } from './components/category-select/category-select.component';
import {TreeExtendedModule} from '@Common/widgets/general/tree-extended/tree-extended.module';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {CustomDateAdapter} from '@Common/core/providers/custom-date-adapter';
import { FilterDirCmpDepositsComponent } from './components/deposit-filters/filter-dir-cmp-deposits/filter-dir-cmp-deposits.component';
import {CommonModuleP8} from '@Common/common-p8.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FilterStateDepositsComponent } from './components/deposit-filters/filter-state-deposits/filter-state-deposits.component';
import { FilterConservationDepositsComponent } from './components/deposit-filters/filter-conservation-deposits/filter-conservation-deposits.component';
import { FilterDemandeurDepositsComponent } from './components/deposit-filters/filter-demandeur-deposits/filter-demandeur-deposits.component';
import { FilterRevisionDepositsComponent } from './components/deposit-filters/filter-revision-deposits/filter-revision-deposits.component';
import { FilterDateDepositsComponent } from './components/deposit-filters/filter-date-deposits/filter-date-deposits.component';
import { InstructionComponent } from './components/instruction/instruction.component';
import {ModaleBoxComponent} from "./components/modales/box/modale-box.component";
import { BoxDetailComponent } from './components/cells-components/box-detail/box-detail.component';
import {UploadFilesComponent} from "./components/files/upload-files/upload-files.component";
import {PiecejointeFormComponent} from "./components/files/upload-files/piecejointe-form/piecejointe-form.component";
import {MatAngularModule} from "@Common/mat-angular.module";
import {DownloadFilesComponent} from "./components/files/download-files/download-files.component";
import { FilterDepositDepositsComponent } from './components/deposit-filters/filter-deposit-deposits/filter-deposit-deposits.component';
import { HomeBoutonsApplicantComponent } from './components/home-boutons-applicant/home-boutons-applicant.component';
import {RouterLink} from '@angular/router';
import { VideoModalComponent } from './components/video-modal/video-modal.component';

@NgModule({
  declarations: [
    CategorySelectComponent,
    FilterDirCmpDepositsComponent,
    FilterStateDepositsComponent,
    FilterConservationDepositsComponent,
    FilterDemandeurDepositsComponent,
    FilterRevisionDepositsComponent,
    FilterDateDepositsComponent,
    InstructionComponent,
    ModaleBoxComponent,
    BoxDetailComponent,
    UploadFilesComponent,
    DownloadFilesComponent,
    PiecejointeFormComponent,
    FilterDepositDepositsComponent,
    HomeBoutonsApplicantComponent,
    VideoModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModuleP8,
    TreeExtendedModule,
    MatAngularModule,
    RouterLink
  ],
    exports: [
        InstructionComponent,
        UploadFilesComponent,
        DownloadFilesComponent,
        DownloadFilesComponent,
        HomeBoutonsApplicantComponent,
    ],
  providers: [
    {provide: DateAdapter, useClass: CustomDateAdapter},
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
  ]
})
export class CommonArchivageModule { }
